// components/ui/FormControls.jsx
export const CountrySelect = ({ value, onChange, countries, placeholder = "—", required = false, error = null }) => (
  <div>
    <select value={value || ""} onChange={(e) => onChange(e.target.value)} required={required} aria-invalid={error ? "true" : "false"}>
      <option value="">{placeholder}</option>
      {countries.map((c) => (
        <option key={c.id} value={String(c.id)}>
          {c.name}
        </option>
      ))}
    </select>
    {error && (
      <div className="field-error" role="alert">
        {error}
      </div>
    )}
  </div>
);

export const ToggleYN = ({ value, onChange, required = false }) => (
  <select value={value || ""} onChange={(e) => onChange(e.target.value)} required={required}>
    <option value="">—</option>
    <option value="Y">Y</option>
    <option value="N">N</option>
  </select>
);

export const MultiSelect = ({ value = [], onChange, options = [] }) => (
  <select multiple value={value} onChange={(e) => onChange(Array.from(e.target.selectedOptions).map((o) => o.value))}>
    {options.map((o) => (
      <option key={o.value} value={o.value}>
        {o.label}
      </option>
    ))}
  </select>
);
